import { PayloadAction } from "@reduxjs/toolkit";

import { Types } from "../../../../services";
import { PaymentModesState } from "../../../../utils/types";

export const pending = (state: PaymentModesState) => {
  state.isLoading = true;
  state.data = null;
  state.isError = false;
  state.isSuccess = false;
};

export const fulfilled = (
  state: PaymentModesState,
  action: PayloadAction<
    Types.ApiResponse<Types.PaymentModesTypes.PaymentModesResponse[]>
  >
) => {
  state.isLoading = false;
  state.isError = false;
  state.isSuccess = action.payload.success;
  state.data = action.payload.response;
};

export const rejected = (state: PaymentModesState, action: any) => {
  state.isLoading = false;
  state.isError = true;
  state.isSuccess = false;
};
